import GlobalLayout from './GlobalLayout';
export default GlobalLayout;
